<template>
  <fragment>
    <TextList :title="currentModule"></TextList>
  </fragment>
</template>

<script>
import ComponentBase from "@/components/mixin/ComponentBase.vue";
import TextList from "@/components/common/TextList.vue";

export default {
  mixins: [ComponentBase],
  components: { TextList },
  data() {
    return {};
  },
  computed: {
    currentModule() {
      return this.$store.state.currentModule;
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped></style>
